// Extracted and exported so the branching is testable: babel.config.js inlines
// process.env.* at transform time, so the env read itself cannot be varied from
// inside a test.
export function resolveLoaderSrc(
  configured: string | undefined,
): string | null {
  const src = configured?.trim();
  if (!src) {
    return null;
  }

  let url: URL;
  try {
    url = new URL(src);
  } catch {
    return null;
  }

  // RFC 6761 reserves the .localhost TLD for loopback, so chat.localhost is as
  // safe as localhost itself — and it is the host the chat shell is served from
  // in development. Matched on a dotted suffix so evil-localhost and
  // localhost.evil.com do not qualify.
  const isLocal =
    url.hostname === 'localhost' ||
    url.hostname.endsWith('.localhost') ||
    url.hostname === '127.0.0.1';
  if (url.protocol !== 'https:' && !(url.protocol === 'http:' && isLocal)) {
    return null;
  }

  return src;
}

export function loaderSrcFromEnv(): string | null {
  return resolveLoaderSrc(process.env.RESPOND_IO_LOADER_SRC);
}

// The backend mints the chat ticket on the API origin — the same host the app's
// JWT already goes to — not on the chat origin. Confirmed with BE: the route is
// on the main urlconf with no host check, but it is called where the token
// already travels.
const TICKET_PATH = '/respondio/ticket';

export function ticketEndpoint(apiUrl: string | undefined): string | null {
  if (!apiUrl) {
    return null;
  }
  try {
    return `${new URL(apiUrl).origin}${TICKET_PATH}`;
  } catch {
    return null;
  }
}

export function ticketEndpointFromEnv(): string | null {
  return ticketEndpoint(process.env.EXPO_PUBLIC_GRADOO_URL);
}
